import { ImageModel } from '@boxx/store-core';
import { createAction, props } from '@ngrx/store';

export enum StoreImagesActionTypes {
  loadImagesBegin = '[STORE] Load Images Begin',
  loadImagesSuccess = '[STORE] Load Images Success',
  loadImagesFail = '[STORE] Load Images Fail',

  loadImageByIdBegin = '[STORE] Load Image By Id Begin',
  loadImageByIdSuccess = '[STORE] Load Image By Id Success',
  loadImageByIdFail = '[STORE] Load Image By Id Fail',

  createImageBegin = '[STORE] Create Image Begin',
  createImageSuccess = '[STORE] Create Image Success',
  createImageFail = '[STORE] Create Image Fail',

  delteImageBegin = '[STORE] Load Delete  Begin',
  delteImageSuccess = '[STORE] Load Delete Success',
  delteImageFail = '[STORE] Delete Image Fail',

  clearImagesSuccessErrorData = '[STORE] Clear Images Success/Error Data',
}

export const loadImagesBeginAction = createAction(
  StoreImagesActionTypes.loadImagesBegin
);

export const loadImagesSuccessAction = createAction(
  StoreImagesActionTypes.loadImagesSuccess,
  props<{ payload: ImageModel[] }>()
);

export const loadImagesFailAction = createAction(
  StoreImagesActionTypes.loadImagesFail,
  props<{ errors: any }>()
);

export const loadImageByIdBeginAction = createAction(
  StoreImagesActionTypes.loadImageByIdBegin,
  props<{ id: number }>()
);

export const loadImageByIdSuccessAction = createAction(
  StoreImagesActionTypes.loadImageByIdSuccess,
  props<{ payload: ImageModel }>()
);

export const loadImageByIdFailAction = createAction(
  StoreImagesActionTypes.loadImageByIdFail,
  props<{ errors: any }>()
);

export const createImageBeginAction = createAction(
  StoreImagesActionTypes.createImageBegin,
  props<{ payload: any }>()
);

export const createImageSuccessAction = createAction(
  StoreImagesActionTypes.createImageSuccess,
  props<{ payload: ImageModel[] }>()
);

export const createImageFailAction = createAction(
  StoreImagesActionTypes.createImageFail,
  props<{ errors: any }>()
);

export const deleteImageBeginAction = createAction(
  StoreImagesActionTypes.delteImageBegin,
  props<{ id: number }>()
);

export const deleteImageSuccessAction = createAction(
  StoreImagesActionTypes.delteImageSuccess,
  props<{ payload: ImageModel[] }>()
);

export const deleteImageFailAction = createAction(
  StoreImagesActionTypes.delteImageFail,
  props<{ errors: any }>()
);

export const clearImagesSuccessErrorDataAction = createAction(
  StoreImagesActionTypes.clearImagesSuccessErrorData
);
